var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestDesktopTriedIt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 14,
  viewBox: "0 0 17 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1.17 4.147c.493 0 1.135-.02 1.677.298.542.32 3.597 3.702 3.597 3.702s7.617-8 8.681-8c.819-.52 1.199.437 1.816 1.329.143.445 0 1.635 0 1.635L6.39 13.147l-6.362-6.5s-.306-2.084 1.143-2.5"
})));
export default SvgPinterestDesktopTriedIt;